var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44 8.01c0 2 1.61 3.59 3.61 3.59.89 0 1.75-.31 2.43-.97.07-.07.09-.2.01-.27l-.62-.64a.184.184 0 0 0-.25 0c-.42.34-.93.57-1.53.57-1.28 0-2.24-1.06-2.24-2.31 0-1.26.95-2.33 2.23-2.33.56 0 1.12.22 1.54.59.08.08.18.08.25 0l.61-.63c.08-.08.08-.2-.01-.28-.68-.61-1.41-.93-2.42-.93-2 0-3.61 1.61-3.61 3.61Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.944de7d8fa8f7064b22866ed1979f1d3.svg";
export { ForwardRef as ReactComponent };